import { render, staticRenderFns } from "./ClassDetailModal.vue?vue&type=template&id=955d684e&scoped=true"
import script from "./ClassDetailModal.vue?vue&type=script&lang=js"
export * from "./ClassDetailModal.vue?vue&type=script&lang=js"
import style0 from "./ClassDetailModal.vue?vue&type=style&index=0&id=955d684e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "955d684e",
  null
  
)

export default component.exports